// LIGHTBOX
const playTriggers = document.querySelectorAll('.c-video-play');
if(playTriggers.length > 0) {
  playTriggers.forEach(videoPlayTrigger => {
    const lightbox = videoPlayTrigger.closest('.c-img-container').nextElementSibling;

    videoPlayTrigger.addEventListener('click', (e) => {
      e.preventDefault();

      openLightbox(lightbox);
    });

    const videoLightboxClose = lightbox.querySelector('.c-lightbox-close');
    videoLightboxClose.addEventListener('click', (e) => {
      e.preventDefault();

      closeLightbox(lightbox);
    });

    // escape key close
    document.addEventListener('keyup', (e) => {
      if(e.key === 'Escape') {
        closeLightbox(lightbox);
      }
    });
  });
  function openLightbox(lightbox) {
    lightbox.classList.add('is-active');
    document.body.classList.add('no-scroll');

    const iframe = lightbox.querySelector('iframe');
    if(iframe) {
      iframe.src = iframe.dataset.src;
    }
  }
  function closeLightbox(lightbox) {
    lightbox.classList.remove('is-active');
    document.body.classList.remove('no-scroll');

    const iframe = lightbox.querySelector('iframe');
    if(iframe) {
      iframe.src = '';
    }
  }
}